import { CONFIGS } from "../../../configs";

const loadSOVGatewayData = async query => {
	const apiHeaders = new Headers();

	const apiConfig = {
		method: "GET",
		headers: apiHeaders,
	};

	const api = CONFIGS.FLIGHTS_SOV.GATEWAYS;
	const apiRequest = new Request(`${api}${query}`);

	return fetch(apiRequest, apiConfig)
		.then(res => {
			if (!res.ok) {
				throw res.error;
			}
			return res.json();
		})
		.catch(err => {
			console.error("Failed to load gateways: ", err);
			return null;
		});
};

export { loadSOVGatewayData };
export default loadSOVGatewayData;
